import { Acf, Image, ImageSizes } from "./wp_types";

// client/src/helpers.ts

export type Option<T> = { kind: 'none' } | { kind: 'some'; value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value
  }
}

export function toRelativeUrl(url: string): string {
  let relative: string = url.replace(`${window.location.protocol}//`, '')
  return relative.indexOf('/') > 0 ? relative.substr(relative.indexOf('/')) : relative
}

export function decodeHTMLEntities(html: string): string {
  let output: Element = document.createElement('div')
  output.innerHTML = html
  return output.textContent
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url
}

export type gtmHash<T> = { [key: string]: T }

export function gtmPush(data: gtmHash<string>) {
  let defaultData: gtmHash<string> = {
    event: 'event.bsl',
    category: '',
    label: window.location.pathname,
    action: ''
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData, ...data });
  } else {
    console.log('DataLayer not found, could not push data: ', { ...defaultData, ...data });
  }
}

interface ContentObject {
  contentInfo: {
    'authors': string // List of authors names from CMS, separated by ";"
    'contentId': string // CMS-Id (number)
    'publishedAt': string // String: date and time (e.g. YYYY MM DD HH:MM:SS)
    'title': string // Title
    'language': string // Language
    'tags': string // metatags for the content, separeted by ";"
  }
}

interface SessionObject {
  authentication: {
    'loginStatus': boolean, // Login: true, Logout: false
    'subscriberId': string, // Subscriber Id from the ODS
    'subscriptions': string // String of all subcription_ids of the subscriber, separated by ";" (list of productIDs subscriber is entitled to (subscribtions in ODS))
  }
}

interface PageObject {
  pageinfo: {
    'destinationURL': string, // Url initially called
    'pageName': string, // Title of Page. Can differ from the content title
    'pageType': string // Grouping of pages in groups/types based on similarities
  }
}

type RecursivePartial<T> = {
  [P in keyof T]?:
    T[P] extends (infer U)[] ? RecursivePartial<U>[] :
    T[P] extends object ? RecursivePartial<T[P]> :
    T[P];
};

interface DatahandlerContent {
  event: string
  category: string
  eventCategory: string
  eventAction: string
  eventLabel: string
  label: string
  action: string
  content: ContentObject
  page: PageObject
  session: SessionObject
}

export function DataLayerHandler(content: RecursivePartial<DatahandlerContent>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(content)
  console.log("Push to Datalayer: ", content)
  console.log("DataLayer: ", window.dataLayer)
}